import React, { createContext, useContext, useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  async function login(email, password) {
    setError("");
    try {
      const r = await api.post("/auth/login", { email, password });
      setUser(r.data);
      return true;
    } catch (e) {
      setError(formatErr(e.response?.data?.detail) || e.message);
      return false;
    }
  }
  async function logout() {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  }

  return (
    <AuthCtx.Provider value={{ user, login, logout, error }}>
      {children}
    </AuthCtx.Provider>
  );
}
